import merge from "lodash/merge"

class ConfInform {
  constructor() {
    this.id = 0
    this.name = ""
    this.content = ""
    this.conference_id = 0
    this.create_time = new Date()
  }
  static getList(filters) {
    const url = process.env.VUE_APP_API_URL + "api/v1/confinform"
    if (!filters.per_page || filters.per_page == "") {
      filters.per_page = -1
    }
    return axios.get(url, { params: filters }).then((res) => {
      let returndata = {}
      returndata.result = []
      let c = new ConfInform()
      res.data.results.forEach((x) => {
        let c = new ConfInform()
        Object.assign(c, x)
        returndata.result.push(c)
      })
      returndata.total = res.data.total
      return returndata
    })
  }

  static async get_by_id(inform_id){
    const res = await ConfInform.getList({id: inform_id})
    if(res.total>0){
      return res.result[0]
    }else{
      return null
    }
  }

  createOrUpdate() {
    const url = process.env.VUE_APP_API_URL + "api/v1/confinform"
    if (this.id == 0) {
      //新增
      const data = merge({}, this)

      return axios.post(url, data).then((res) => {
        let result = new ConfInform()
        result = merge(result, res)
        return result
      })
    } else {
      //修改
      const data = merge({}, this)

      return axios.put(url, data).then((res) => {
        let result = new ConfInform()
        result = merge(result, res.data.item)
        return result
      })
    }
  }
  static delete(id) {
    const url = process.env.VUE_APP_API_URL + "api/v1/confinform"
    return axios.delete(url, { params: { id: id } }).then((res) => {
      return true
    })
  }
}
export { ConfInform }
